// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 获取发展历程
export function developmentHistory(params) {
  return request({
    url: "/api/about_us/history",
    method: "get",
    params,
  });
}





